<div class="app">
  <mat-progress-bar *ngIf="showLoader" mode="indeterminate" color="ascent"></mat-progress-bar>
  <app-navbar></app-navbar>
  <router-outlet></router-outlet>
  <app-footer></app-footer>
  <app-loader *ngIf="showLoader"></app-loader>
</div>
<app-modal></app-modal>